import React from "react";
import { TileWrapper } from "./tabContent";
import styled from "styled-components";
import { SkeletonPlaceholder } from "@carbon/react";
const TileOuter = styled.div `
	background: var(--cds-layer-02, #f4f4f4);
	display: flex;
	width: 300px;
	height: 300px;
	padding: 16px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
`;
const TileSkeleton = styled(SkeletonPlaceholder) `
	width: 100%;
	height: 100%;
`;
export const TabContentSkeleton = () => (React.createElement(TileWrapper, null, Array(6)
    .fill("_")
    .map((_, i) => (React.createElement(TileOuter, { key: `tile-skeleton-${i}-${Math.random() * 10000}` },
    React.createElement(TileSkeleton, null))))));
